import React from "react";

const TicketCount = ({ row }) => {
  return (
    <div>
      <div style={{ paddingBottom: "10px" }}>{row?.ticketCount}</div>
    </div>
  );
};

export default TicketCount;
